import { useConfirm } from "@placehires/react-component-library";

export const useConfirmDelete = () => useConfirm({ title: "Confirm to delete" });
